import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import { useAuthContext } from '../../context/authContext';
import Module from '../../components/Module';
import styles from '../../styles/Dashboard.module.scss';
import Logo from '../../components/Logo';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentMenuFromStorage } from '../../services/localStorage';
import { LEVELS } from '../../components/Menu';
import { setFirstLoadPage } from '../../redux/actions/dashboardActions';
import SearchResults from '../../components/SearchResults';
import FavoriteVideos from '../../components/FavoriteVideos';
import { getUserInfo, UserModel } from '../../context/authContext/authActions';
import AlertDismissible from '../../components/AlertDismissible';
import { getSectionById } from '../../redux/actions/sectionActions';
import { getModuleById } from '../../redux/actions/moduleActions';
import { openVideoFromMenu } from '../../redux/actions/videoActions';
import CustomSpinner from '../../components/CustomSpinner';
import {
  getScreenerStatus,
  dismissScreener,
  getScreener,
  getKnowledgeCheck,
} from '../../redux/actions/screenersActions';
import { Modal, Jumbotron } from 'react-bootstrap';
import Screener from '../../components/Screener';
import {
  PRODUCT_NAME,
  COMPANY_LEGAL_NAME,
  PRODUCT_SUPPORT_EMAIL,
  PRODUCT_WEBSITE,
} from '../../constants/constants';
import { getTotalVideoProgresses } from '../../redux/actions/sectionActions';

import DownloadLinks from '../../components/DownloadLinks';
import AppDownloadPopup from '../../components/AppDownloadPopup';

const Dashboard = (props) => {
  const dispatch = useDispatch();

  const { searchValue } = useSelector((state) => state.search);
  const { openFavoriteSection } = useSelector((state) => state.favorite);
  const { currentModule, loadingCurrentModule } = useSelector(
    (state) => state.module
  );
  const { currentSection } = useSelector((state) => state.section);
  const { courses } = useSelector((state) => state.course);
  const { firstLoadPage, globalLoading } = useSelector(
    (state) => state.dashboard
  );

  const {
    state: { user },
  } = useAuthContext();

  const [showSearchPage, setShowSearchPage] = useState();
  const [showModule, setShowModule] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const [showScreenerModal, setShowScreenerModal] = useState(false);
  const [eventScreener, setEventScreener] = useState(null);
  const [knowledgeChecks, setKnowledgeChecks] = useState([]);

  const prioritySort = (a, b) => {
    const priorityMap = {
      1: 0,
      3: 1,
      2: 2,
      0: 3,
    };

    return priorityMap[a.event_type] - priorityMap[b.event_type];
  };

  useEffect(() => {
    const fetchScreenerStatus = async () => {
      if (user) {
        const ebs = user.event_based_screeners.sort(prioritySort);
        // Prioritize user first login ev or login ev
        for (let user_ebs of ebs) {
          console.log('event based screener', ebs);
          // check status of login ev type 1 & 3
          if (
            (user_ebs.event_type == 1 && user.login_count == 0) ||
            user_ebs.event_type == 3
          ) {
            const screenerStatus = await checkScreenerLoginEventStatus(
              user_ebs
            );
            if (screenerStatus) {
              break;
            }
          }

          // Content time ev
          if (user_ebs.event_type == 2) {
            const screenerStatus = await checkScreenerContentEventStatus(user_ebs);
            if (screenerStatus) {
              // content time theshold exceeded we show the ebs
              break;
            }
          }
        }
      }
    };

    fetchScreenerStatus();
  }, [user]);

  const checkScreenerContentEventStatus = async (user_ebs) => {
    try {
      const screenerEventStatus = await getScreenerStatus(user_ebs.id, user.id);

      const screener = await getScreener(user_ebs.id);
      setEventScreener(screener);

      // check for uncompleted event
      if (
        screenerEventStatus.completed == false &&
        screenerEventStatus.dismissed < screener.max_dismissals
      ) {
        const contentTime = await getTotalVideoProgresses();

        // Check if content time exceed the event based q threshold
        if (
          contentTimeExceedThreshold(
            contentTime.total_video_progresses,
            user_ebs.event_params
          )
        ) {
          const kc = await getKnowledgeCheck(screener.knowledge_check_id);
          setKnowledgeChecks([kc]);

          setShowScreenerModal(true);

          // Threshold exceeded return true
          return true;
        }
        // return false, ebs completed or max dismissals reached
        return false;
      }
    } catch (err) {
      console.log(err.message);
      return false;
    }
  };

  function contentTimeExceedThreshold(contentTimeInSeconds, thresholdInHours) {
    // Convert threshold from hours to seconds for comparison
    const thresholdInSeconds = thresholdInHours * 3600;

    return contentTimeInSeconds > thresholdInSeconds;
  }

  const checkScreenerLoginEventStatus = async (user_ebs) => {
    try {
      const screenerEventStatus = await getScreenerStatus(user_ebs.id, user.id);

      const screener = await getScreener(user_ebs.id);
      setEventScreener(screener);

      // check for uncompleted event
      if (
        screenerEventStatus.completed == false &&
        screenerEventStatus.dismissed < screener.max_dismissals
      ) {
        const kc = await getKnowledgeCheck(screener.knowledge_check_id);
        setKnowledgeChecks([kc]);

        setShowScreenerModal(true);
        return true;
      }
      return false;
    } catch (err) {
      console.log(err.message);
      return false;
    }
  };

  const goBack = async () => {
    try {
      const screenerEventStatus = await dismissScreener(
        eventScreener.id,
        user.id
      );
    } catch (err) {
      console.log(err.message);
    }

    setEventScreener(null);
    setKnowledgeChecks(null);
    setShowScreenerModal(false);
  };

  useEffect(() => {
    setShowSearchPage(searchValue !== '');
  }, [searchValue]);

  // init course, module, section
  useEffect(() => {
    if (courses.length > 0 && firstLoadPage) {
      let data = getCurrentMenuFromStorage();

      let module_id = data[LEVELS.CURRENT_MODULE];
      let section_id = data[LEVELS.CURRENT_SECTION];
      let video_id = data[LEVELS.CURRENT_VIDEO];

      if (video_id !== 0) {
        dispatch(openVideoFromMenu(video_id, section_id ? section_id : 0));
      } else if (section_id !== 0) {
        dispatch(getSectionById(section_id));
      } else {
        dispatch(getModuleById(module_id));
      }

      // prevent to execute this useEffect again
      // only execute when first reload or press f5
      dispatch(setFirstLoadPage());
    }

    // eslint-disable-next-line
  }, [courses, firstLoadPage]);

  useEffect(() => {
    if (user) {
      getUserInfo(user.id).then(
        (response) => {
          let userModel = new UserModel(response.user);

          // Update user token in local storage
          localStorage.setItem('user', JSON.stringify(userModel));
        },
        () => {}
      );
    }
  }, [user]);

  useEffect(() => {
    if (props.location.search) {
      const searchQuery = props.location.search.replace('?', '');
      const queryParams = searchQuery.split('&');

      if (queryParams[0].indexOf('confirmed') !== -1) {
        let confirmed = queryParams[0].split('=');
        let value = confirmed[1];

        setShowAlert(value);
      }
    }
  }, [props.location.search]);

  const onCloseAlert = () => {
    window.history.replaceState(null, '', '/dashboard');
    setShowAlert((prevShowAlert) => !prevShowAlert);
  };

  useEffect(() => {
    setShowModule(!!currentModule && !showSearchPage);
  }, [currentModule, currentSection, showSearchPage]);

  const renderContent = () => {
    <DownloadLinks />;

    if (loadingCurrentModule) {
      return <CustomSpinner />;
    }

    if (showSearchPage) {
      return <></>;
    }

    if (openFavoriteSection) {
      return <FavoriteVideos />;
    }

    if (showModule) {
      return <Module />;
    }

    if (
      user &&
      user.main_school_graphic &&
      user.main_school_graphic.length > 0
    ) {
      return (
        <div id="org-graphic-container">
          <h1>
            <img
              tabIndex="0"
              alt={
                user.schools[0].notes
                  ? user.schools[0].notes
                  : { PRODUCT_NAME } + ' Disctrict Welcome Image'
              }
              src={user.main_school_graphic}
            />
          </h1>
        </div>
      );
    }

    return <></>;
  };

  return (
    <>
      {eventScreener ? (
        <Modal size="lg" show={showScreenerModal} fullscreen={'true'}>
          <Modal.Body>
            <Screener
              content={knowledgeChecks}
              screener={eventScreener}
              goBack={goBack}
            />
          </Modal.Body>
        </Modal>
      ) : (
        ''
      )}

      <div className={styles['dashboard-container']}>
        <Row>
          <Col className={`pl-0 pl-md-3`} md={3} xs={12}>
            <div className="d-none d-md-block logo mt-3 mt-sm-0">
              <header>
                <Logo />
              </header>
            </div>
            <div className="d-block d-md-none logo mt-3 mt-sm-0">
              <header>
                <Logo />
              </header>
            </div>
          </Col>

          <Col md={9} xs={12}>
            <aside aria-label="Search videos">
              <Header user={user} />
            </aside>

            {showAlert ? (
              <AlertDismissible
                variant={'info'}
                content={`Your email address has been confirmed`}
                showAlert={showAlert}
                onCloseAlert={onCloseAlert}
              />
            ) : (
              // OR
              ''
            )}
          </Col>
        </Row>

        <Row>
          <Col className={`pl-0 pl-md-3`} md={3} xs={12}>
            <nav aria-label="Main menu">
              <Sidebar />
            </nav>
          </Col>

          <Col md={9} xs={12}>
            <main>
              {renderContent()}
              <SearchResults display={showSearchPage} />
            </main>
          </Col>
        </Row>
        {/*Spinner or Blocking Modal*/}
        {globalLoading && (
          <div className="loading">
            <div className="loader"></div>
          </div>
        )}
      </div>

      <AppDownloadPopup />

      <div className={styles['dashboard-footer']}>
        <p className="font-13 font-poppins .text-color-tertiary m-0">
          All Rights Reserved © {new Date().getFullYear()} {COMPANY_LEGAL_NAME}
          <span className="text-color-secondary font-weight-bolder mx-2">
            |
          </span>{' '}
          <a
            className={`font-13 font-poppins text-color-tertiary text-decoration-none`}
            target="_blank"
            href={PRODUCT_WEBSITE + '/privacy/'}
          >
            Privacy Policy
          </a>
          <br></br> <br></br>
          <DownloadLinks />
        </p>

        <p className="font-13 font-poppins text-color-tertiary m-0">
          Need Help?{' '}
          <span className="text-color-secondary font-weight-bolder mx-2">
            |
          </span>{' '}
          <a
            className={`font-13 font-poppins text-color-tertiary text-decoration-none`}
            href={'mailto:' + PRODUCT_SUPPORT_EMAIL}
          >
            {PRODUCT_SUPPORT_EMAIL}
          </a>
          <br></br>
          <br></br>
          <br></br>&nbsp;
        </p>
      </div>
    </>
  );
};

export default React.memo(Dashboard);
